'use client';

import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import styles from './Logo.module.css';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  className = '' 
}) => {
  const router = useRouter();

  const handleLogoClick = () => {
    router.push('/');
  };

  return (
    <div 
      className={`${styles.logoContainer} ${className}`}
      onClick={handleLogoClick}
    >
      <Image 
        src="/icons/logo-large.svg" 
        alt="PIF Global Series Logo" 
        className={styles.logoImage}
        width={200}
        height={60}
        priority
      />
    </div>
  );
};

export default Logo; 